var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.equipment
    ? _c(
        "div",
        [
          _c("div", { staticClass: "row my-1 align-items-end" }, [
            _c("div", { staticClass: "col-2" }, [
              _c("label", { staticClass: "small fw-bold" }, [
                _vm._v(_vm._s(_vm.$t("testEquipment.edit.number")))
              ]),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "text", disabled: "disabled" },
                domProps: { value: _vm.equipment.itemNo || "" }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-2" },
              [
                _c("label", { staticClass: "small fw-bold" }, [
                  _vm._v(_vm._s(_vm.$t("testEquipment.edit.placeofuse")))
                ]),
                _vm._v(" "),
                _c("vSelect", {
                  attrs: {
                    options: _vm.state.placeOfUsesStore.placeOfUseTypes,
                    label: "name",
                    reduce: place => place.id,
                    clearable: false,
                    disabled: !_vm.editable
                  },
                  model: {
                    value: _vm.equipment.placeOfUseShortId,
                    callback: function($$v) {
                      _vm.$set(_vm.equipment, "placeOfUseShortId", $$v)
                    },
                    expression: "equipment.placeOfUseShortId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-2" },
              [
                _c("label", { staticClass: "small fw-bold" }, [
                  _vm._v(_vm._s(_vm.$t("testEquipment.edit.name")))
                ]),
                _vm._v(" "),
                _c("vSelect", {
                  attrs: {
                    options: _vm.state.groupsStore.groupTypes,
                    label: "name",
                    reduce: group => group.id,
                    clearable: false,
                    disabled: !_vm.editable || _vm.equipment.id > 0
                  },
                  model: {
                    value: _vm.equipment.groupId,
                    callback: function($$v) {
                      _vm.$set(_vm.equipment, "groupId", $$v)
                    },
                    expression: "equipment.groupId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-2" },
              [
                _c("label", { staticClass: "small fw-bold" }, [
                  _vm._v(_vm._s(_vm.$t("testEquipment.edit.kindOf")))
                ]),
                _vm._v(" "),
                _c("vSelect", {
                  attrs: {
                    options: _vm.state.kindsStore.kindTypes,
                    label: "name",
                    reduce: kind => kind.id,
                    clearable: false,
                    disabled: !_vm.editable
                  },
                  model: {
                    value: _vm.equipment.kindId,
                    callback: function($$v) {
                      _vm.$set(_vm.equipment, "kindId", $$v)
                    },
                    expression: "equipment.kindId"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-4" }, [
              _c("label", { staticClass: "small fw-bold" }, [
                _vm._v(_vm._s(_vm.$t("testEquipment.edit.ident")))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.ident,
                    expression: "equipment.ident"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.ident },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "ident", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-3" }, [
            _c("div", { staticClass: "col-2 d-flex align-items-center" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.title")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.name,
                    expression: "equipment.name"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "name", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("div", { staticClass: "row my-1" }, [
                _c("div", { staticClass: "col-4 d-flex align-items-center" }, [
                  _vm._v(_vm._s(_vm.$t("testEquipment.edit.dateOut")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-8" }, [
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("Datepicker", {
                        attrs: {
                          "monday-first": true,
                          language: _vm.datepickerDE,
                          "bootstrap-styling": true,
                          disabled: !_vm.editable
                        },
                        model: {
                          value: _vm.equipment.entryDate,
                          callback: function($$v) {
                            _vm.$set(_vm.equipment, "entryDate", $$v)
                          },
                          expression: "equipment.entryDate"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row my-1" }, [
                _c("div", { staticClass: "col-4 d-flex align-items-center" }, [
                  _vm._v(_vm._s(_vm.$t("testEquipment.edit.issueDate")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-8" }, [
                  _c(
                    "div",
                    { staticClass: "input-group" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("Datepicker", {
                        attrs: {
                          "monday-first": true,
                          language: _vm.datepickerDE,
                          "bootstrap-styling": true,
                          disabled: !_vm.editable
                        },
                        model: {
                          value: _vm.equipment.issueDate,
                          callback: function($$v) {
                            _vm.$set(_vm.equipment, "issueDate", $$v)
                          },
                          expression: "equipment.issueDate"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.intervall")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.intervalValue,
                    expression: "equipment.intervalValue"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.intervalValue },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.equipment,
                      "intervalValue",
                      $event.target.value
                    )
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-8" },
              [
                _c("vSelect", {
                  attrs: {
                    options: _vm.state.timeUnitsStore.timeUnits,
                    label: "name",
                    reduce: unit => unit.id,
                    clearable: false,
                    disabled: !_vm.editable
                  },
                  model: {
                    value: _vm.equipment.intervalUnitId,
                    callback: function($$v) {
                      _vm.$set(_vm.equipment, "intervalUnitId", $$v)
                    },
                    expression: "equipment.intervalUnitId"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.intervallWarning")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.warningValue,
                    expression: "equipment.warningValue"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "number", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.warningValue },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "warningValue", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-8" },
              [
                _c("vSelect", {
                  attrs: {
                    options: _vm.state.timeUnitsStore.timeUnits,
                    label: "name",
                    reduce: unit => unit.id,
                    clearable: false,
                    disabled: !_vm.editable
                  },
                  model: {
                    value: _vm.equipment.warningUnitId,
                    callback: function($$v) {
                      _vm.$set(_vm.equipment, "warningUnitId", $$v)
                    },
                    expression: "equipment.warningUnitId"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.status")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.status,
                    expression: "equipment.status"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.status },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "status", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.placeofuse")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.placeOfUse,
                    expression: "equipment.placeOfUse"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.placeOfUse },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "placeOfUse", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.responsible")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.responsible,
                    expression: "equipment.responsible"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.responsible },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "responsible", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.warningmail")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.warningMail,
                    expression: "equipment.warningMail"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.warningMail },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "warningMail", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.supplier")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.deviceManufacturer,
                    expression: "equipment.deviceManufacturer"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.deviceManufacturer },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.equipment,
                      "deviceManufacturer",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.type")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.deviceType,
                    expression: "equipment.deviceType"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.deviceType },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "deviceType", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.serial")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.deviceSerialNumber,
                    expression: "equipment.deviceSerialNumber"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.deviceSerialNumber },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.equipment,
                      "deviceSerialNumber",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.testarea")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.testSpecification,
                    expression: "equipment.testSpecification"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.testSpecification },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.equipment,
                      "testSpecification",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.tolerance")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.errorMargin,
                    expression: "equipment.errorMargin"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.errorMargin },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "errorMargin", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.testMethod")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.testProcedure,
                    expression: "equipment.testProcedure"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.testProcedure },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.equipment,
                      "testProcedure",
                      $event.target.value
                    )
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.costCenter")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.costCenter,
                    expression: "equipment.costCenter"
                  }
                ],
                staticClass: "form-control",
                attrs: { type: "text", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.costCenter },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "costCenter", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row my-1" }, [
            _c("div", { staticClass: "col-2" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.comment")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-10" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.equipment.note,
                    expression: "equipment.note"
                  }
                ],
                staticClass: "form-control",
                attrs: { rows: "2", disabled: !_vm.editable },
                domProps: { value: _vm.equipment.note },
                on: {
                  input: function($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.equipment, "note", $event.target.value)
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _vm.showArchiveFields
            ? [
                _c("div", { staticClass: "row my-1 bg-light p-2 rounded" }, [
                  _c("div", { staticClass: "col-2 fw-bold" }, [
                    _vm._v("Grund")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4" }, [
                    _vm._v(_vm._s(_vm.equipment.archiveReason))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2 fw-bold" }, [
                    _vm._v("Risiko")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-10" }, [
                    _vm._v(_vm._s(_vm.archiveRisk))
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row my-2" }, [
            _c("div", { staticClass: "col small text-muted" }, [
              _vm._v(_vm._s(_vm.$t("testEquipment.edit.mandatory")))
            ])
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("TestEquipmentMeasurementSpecifications", {
            attrs: { container: _vm.equipment, editable: _vm.editable }
          }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("ImageViewer", {
            attrs: {
              isShowDelete: _vm.allowMediaDelete,
              medias: _vm.equipment.files
            },
            on: {
              "removed-media": function($event) {
                return _vm.removeMedia($event)
              }
            }
          }),
          _vm._v(" "),
          _c("DropZone", {
            staticClass: "mt-2",
            attrs: { formId: "dz_equipment" + _vm._uid },
            on: { uploaded: _vm.fileUploaded }
          }),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-2"
            },
            [
              _c("h5", { staticClass: "mb-0" }, [_vm._v("Tests")]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.exportCSV }
                },
                [
                  _c("i", { staticClass: "fa fa-download" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("testEquipment.edit.export")) + "\n    "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("VueGoodTable", {
            ref: "table",
            attrs: {
              columns: _vm.testColumns,
              rows: _vm.tests || [],
              isLoading: _vm.tests === null,
              "pagination-options": _vm.paginationOptions,
              "select-options": _vm.selectConfig,
              "search-options": _vm.searchOptions
            },
            on: { "on-row-click": _vm.onClick },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-row",
                  fn: function(props) {
                    return [
                      props.column.field === "actions"
                        ? _c("div", { staticClass: "btn-group" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-secondary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.exportTest(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-file-excel" })]
                            )
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(props.formattedRow[props.column.field])
                            )
                          ])
                    ]
                  }
                }
              ],
              null,
              false,
              3663583003
            )
          }),
          _vm._v(" "),
          _c("TestEquipmentTestEditModal", {
            ref: "testModal",
            on: {
              "file-added": function($event) {
                return _vm.$emit("test-file-added", $event)
              }
            }
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fa fa-calendar" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fa fa-calendar" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }